// extracted by mini-css-extract-plugin
export default {"filter":"FilterModule_filter__63Yfy"};